// src/components/shared/ImageCard.js
import React, { useState } from "react";
import { Card, Button } from "react-bootstrap";

const ImageCard = ({ image, imageUrl, onEdit, onDelete }) => {
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);

  const handleDeleteClick = () => {
    setShowDeleteConfirm(true);
  };

  const handleCancelDelete = () => {
    setShowDeleteConfirm(false);
  };

  const handleConfirmDelete = () => {
    onDelete(image.id);
    setShowDeleteConfirm(false);
  };
  return (
    <Card
      text="light"
      className="h-100 image-card shadow-sm"
      style={{ borderColor: "#444", width: "100%", backgroundColor: "#121212" }}
    >
      <div
        className="image-container"
        style={{
          position: "relative",
          paddingTop: "75%",
          overflow: "hidden",
        }}
      >
        <Card.Img
          src={imageUrl}
          alt={image.alt_text || "Image"}
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            objectFit: "cover",
          }}
        />
      </div>
      <Card.Body className="p-2">
        <div>
          <Card.Title className="text-truncate fs-6">
            {image.description || "Untitled Image"}
          </Card.Title>
          <Card.Text className="small mb-2">
            {image.upload_date
              ? new Date(image.upload_date).toLocaleDateString()
              : "Unknown date"}
          </Card.Text>
          <div className="d-flex gap-1 mt-2 position-relative">
            <Button
              variant="outline-primary"
              size="sm"
              className="px-2 py-0 flex-grow-1"
              onClick={() => onEdit(image.id)}
            >
              Edit
            </Button>
            <Button
              variant="outline-danger"
              size="sm"
              className="px-2 py-0 flex-grow-1"
              onClick={handleDeleteClick}
            >
              Delete
            </Button>
            {showDeleteConfirm && (
              <div
                className="position-absolute bg-dark border border-secondary rounded p-2"
                style={{
                  left: 0,
                  top: "100%",
                  zIndex: 1000,
                  width: "100%",
                }}
              >
                <p className="small text-light mb-2">Are you sure?</p>
                <div className="d-flex gap-2">
                  <Button
                    variant="danger"
                    size="sm"
                    className="flex-grow-1"
                    onClick={handleConfirmDelete}
                  >
                    Delete
                  </Button>
                  <Button
                    variant="secondary"
                    size="sm"
                    className="flex-grow-1"
                    onClick={handleCancelDelete}
                  >
                    Cancel
                  </Button>
                </div>
              </div>
            )}
          </div>
        </div>
      </Card.Body>
    </Card>
  );
};

export default ImageCard;
